import { Tooltip } from 'react-tooltip';
import 'reactjs-tiptap-editor/style.css';
import { FIREBASE_STORAGE_URL } from '../../app-settings';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { classNames } from '../../style/common';
import "./TipTapContent.scss";
import "./TipTap.scss";

export type TipTapContentProps = {
    content: string
}

export function TipTapContent(props: TipTapContentProps) {
    const isDarkMode = useSelector<RootState, boolean>(x => x.user.userSettings.isDarkMode);

    return (
        <div>
            <div className={classNames(`tiptap ProseMirror`, isDarkMode && "dark")} dangerouslySetInnerHTML={{ __html: props.content ?? "" }}>
            </div>

            <Tooltip
                id="image-tooltip"
                place="top-end"
                className="!bg-none !p-0 !z-50 !opacity-100"
                render={({ content, activeAnchor }) => (
                    <img
                        style={{ aspectRatio: "143/200", zIndex: "1" }}
                        src={`${FIREBASE_STORAGE_URL}/images/cards/${content}.jpg`}
                        loading="lazy"
                        className={`relative rounded-2xl w-[300px] max-w-[300px] min-w-[200px]`} />
                )} />
        </div>
    )
}